import { Box, IconButton, Popover, Tooltip } from '@mui/material'
import { useEffect, useState } from 'react'
import { Picker } from 'emoji-mart'

import 'emoji-mart/css/emoji-mart.css'

const EmojiPicker = ({ icon, onChange }) => {
  const [selectedEmoji, setSelectedEmoji] = useState(icon)
  const [anchorEl, setAnchorEl] = useState(null)

  useEffect(() => {
    setSelectedEmoji(icon)
  }, [icon])

  const selectEmoji = (event) => {
    const sym = event.unified.split('-')
    const codesArray = sym.map((code) => `0x${code}`)
    const emoji = String.fromCodePoint(...codesArray)
    setAnchorEl(null)
    onChange(emoji)
  }

  return (
    <Box>
      <Tooltip title='Change board icon'>
        <IconButton
          onClick={(event) => setAnchorEl(event.currentTarget)}
          aria-label='Change board icon'
          sx={{
            width: 44,
            height: 44,
            fontSize: '1.375rem',
            borderRadius: 2,
            border: '1px solid',
            borderColor: 'divider',
            backgroundColor: 'background.paper',
            '&:hover': { borderColor: 'primary.main' }
          }}
        >
          <Box component='span' aria-hidden>
            {selectedEmoji || '📄'}
          </Box>
        </IconButton>
      </Tooltip>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{ sx: { borderRadius: 3, overflow: 'hidden', mt: 1 } }}
      >
        <Picker theme='dark' onSelect={selectEmoji} showPreview={false} />
      </Popover>
    </Box>
  )
}

export default EmojiPicker
